import React, { useMemo, useCallback } from 'react'
import { useNavigation, CommonActions } from '@react-navigation/native'
import styled from 'styled-components/native'

import Logo from 'APP/Components/Logo'
import { MenuNavList } from './MenuNavList'

import { Images } from 'APP/Themes'
import Config from 'APP/Config'

const MenuContainer = styled.View`
  flex: 1;
  margin-vertical: ${({ theme }) => theme.metrics.baseMargin}px;
`

const MenuLogoContainer = styled.View`
  width: auto;
  align-items: center;
  justify-content: center;
  margin-vertical: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

const MenuExpandingSpace = styled.View`
  flex-grow: 1;
`

const MenuDivider = styled.View`
  height: 0px;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.colors.separateLine};
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
`

export function stackRouteToName(route) {
  const nestedName = route?.state?.routes[route?.state?.index]?.name

  return nestedName || route?.name
}

export function getSelectedMenuItemName({ stackIndex, stackRoutes, menuRouteNames }) {
  const afterMenuRoute = stackRoutes[stackIndex + 1]
  const afterMenuRouteIsInMenu =
    afterMenuRoute && menuRouteNames.indexOf(afterMenuRoute?.name) !== -1
  const selectedRoute = afterMenuRouteIsInMenu ? afterMenuRoute : stackRoutes[stackIndex]

  return stackRouteToName(selectedRoute)
}

const resetToMenuRouteWhenNotTopOfStack = async ({ stackIndex, stackRoutes, navigation }) => {
  const lastRouteIndex = stackRoutes?.length - 1
  if (stackIndex !== lastRouteIndex) {
    await navigation.dispatch(
      CommonActions.reset({
        index: stackIndex,
        routes: stackRoutes.slice(0, stackIndex + 1),
      })
    )
  }
}

const handleNavigate = async ({ name, stackIndex, stackRoutes, navigation }) => {
  await resetToMenuRouteWhenNotTopOfStack({ stackIndex, stackRoutes, navigation })
  await navigation.dispatch(CommonActions.navigate(name))
}

const getRouteNamesFromMenuChildren = (children) =>
  children
    .flatMap(({ props }) => props?.items)
    .filter((items) => !!items)
    .map(({ name }) => name)

export const Menu = ({ children = [], stackIndex, stackRoutes, testID, ...rest }) => {
  const navigation = useNavigation()
  const menuChildren = React.Children.toArray(children)
  const menuRouteNames = useMemo(() => getRouteNamesFromMenuChildren(menuChildren), [menuChildren])
  const selectedItemName = useMemo(
    () => getSelectedMenuItemName({ stackIndex, stackRoutes, menuRouteNames }),
    [stackIndex, stackRoutes, menuRouteNames]
  )
  const onItemPress = useCallback(
    (name) => handleNavigate({ name, stackIndex, navigation, stackRoutes }),
    [stackIndex, stackRoutes, navigation]
  )
  return (
    <MenuContainer testID={testID}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { ...rest, selectedItemName, onItemPress })
      )}
    </MenuContainer>
  )
}

const MenuLogo = (props) => (
  <MenuLogoContainer>
    <Logo source={Images.logoLockup} height={Config.LOGO_HEIGHT || 30} {...props} />
  </MenuLogoContainer>
)

Menu.Divider = MenuDivider
Menu.NavList = MenuNavList
Menu.ExpandingSpace = MenuExpandingSpace
Menu.Logo = MenuLogo
